import { BenchmarkMetric } from "./BenchmarkMetric";

const producers = [
  ["GPT-5.4", "1,380 / 1,384", "99.71%"],
  ["Claude Sonnet 4.6", "1,376 / 1,383", "99.49%"],
  ["DeepSeek V3.2", "1,377 / 1,380", "99.78%"],
  ["Kimi K2.5", "1,380 / 1,384", "99.71%"],
  ["Gemini 3 Flash", "1,379 / 1,380", "99.93%"],
];

export function StylomeLargeStoryScopeReport() {
  return (
    <details className="benchmark-report">
      <summary>
        <span className="benchmark-identity">
          <span className="metadata-line">Stylome 1.2 Large · StoryScope</span>
          <strong>StoryScope</strong>
          <span>AI-generated fiction from five models.</span>
        </span>
        <span
          className="benchmark-summary-metrics"
          aria-label="Stylome 1.2 Large StoryScope highlights"
        >
          <BenchmarkMetric
            label="AI-generated recall · 0.01% FPR target"
            value="99.73%"
            context="6,892 of 6,911 outputs classified as AI-generated"
          />
        </span>
        <span className="benchmark-toggle">Full results</span>
      </summary>
      <div className="benchmark-body">
        <p className="benchmark-context">
          Stylome 1.2 Large correctly classified 6,892 of 6,911 eligible{" "}
          <a
            href="https://huggingface.co/datasets/jjrussell10/storyscope"
            target="_blank"
            rel="noreferrer"
          >
            StoryScope
          </a>{" "}
          test outputs as AI-generated at the fixed 0.01% calibration FPR
          target. Six were labeled AI-edited and 13 human; neither counts as
          correct here.
        </p>
        <div
          className="table-wrap threshold-table"
          role="region"
          aria-label="Stylome 1.2 Large StoryScope results"
          tabIndex={0}
        >
          <table>
            <caption>
              StoryScope exact AI-generated recall · 0.01% FPR target
            </caption>
            <thead>
              <tr>
                <th>Producer</th>
                <th>Correct / scored</th>
                <th>AI-generated recall</th>
              </tr>
            </thead>
            <tbody>
              {producers.map(([producer, count, recall]) => (
                <tr key={producer}>
                  <th scope="row">{producer}</th>
                  <td>{count}</td>
                  <td>{recall}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="fine evaluation-note">
          Evaluated September 19, 2026, and rescored September 29, 2026. Long
          stories (6,253) use their first 10,000 normalized characters; 658
          shorter outputs were scored in full. Three missing outputs and six
          under 200 characters were excluded. Human story texts are not
          supplied, so false-positive rate cannot be measured here.
        </p>
      </div>
    </details>
  );
}
